module.exports = __webpack_public_path__ + "static/media/appletv-black-circle.b45eaaaa.svg";